
/* eslint-disable */
// src/pages/PravachanReport.tsx
// + PDF viewing in detail panel

import React, { useEffect, useState, useRef } from 'react';
import { dbRealtime } from '../environments/firebase';
import { ref, get, update, remove, set } from 'firebase/database';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

// ─── Theme ────────────────────────────────────────────────────
const T = {
  bg:       '#F7F5F0',
  surface:  '#FFFFFF',
  surface2: '#F0EDE8',
  border:   '#E5E0D8',
  text:     '#1A1714',
  muted:    '#8A8178',
  accent:   '#C2610A',
  accentBg: '#FEF3E8',
  green:    '#15803D',
  red:      '#DC2626',
  shadow:   '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
};

// ─── Icons ────────────────────────────────────────────────────
const Ic = {
  Folder:   () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>,
  File:     () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Download: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Edit:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash:    () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>,
  Globe:    () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
  Back:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>,
  Grid:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  List:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  Search:   () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Close:    () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Play:     () => <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Pause:    () => <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>,
  Plus:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Unpost:   () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
  Pdf:      () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  ExtLink:  () => <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
};

type PravachanEntry = {
  timestamp: string;
  vakta: string;
  topic: string;
  dateTime: string;
  notes: string;
  caption?: string;
  images?: string[];
  audioFiles?: string[];
  pdfFiles?: { url: string; label: string }[];
  createdAt?: number;
  folderId?: string | null;
  isPublic?: boolean;
  dateObj: Date;
};

type FolderItem = { id: string; name: string; parentId: string|null; createdAt: number; };

// ─── Audio player ─────────────────────────────────────────────
function AudioBar({ src }: { src: string }) {
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(0);
  const aRef = useRef<HTMLAudioElement>(null);
  const toggle = () => { if (!aRef.current) return; if (playing) { aRef.current.pause(); setPlaying(false); } else { aRef.current.play(); setPlaying(true); } };
  const pct = dur ? (time/dur)*100 : 0;
  const fmt = (s: number) => `${Math.floor(s/60)}:${Math.floor(s%60).toString().padStart(2,'0')}`;
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10, background:T.surface2, borderRadius:10, padding:'8px 12px', border:`1px solid ${T.border}` }}>
      <button onClick={toggle} style={{ width:32, height:32, borderRadius:'50%', background:T.accent, color:'#fff', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
        {playing ? <Ic.Pause /> : <Ic.Play />}
      </button>
      <div style={{ flex:1, height:4, background:T.border, borderRadius:2, cursor:'pointer', position:'relative' }}
        onClick={e => { if (!aRef.current||!dur) return; const r=e.currentTarget.getBoundingClientRect(); aRef.current.currentTime=((e.clientX-r.left)/r.width)*dur; }}>
        <div style={{ height:'100%', background:T.accent, borderRadius:2, width:`${pct}%`, transition:'width 0.1s' }} />
      </div>
      <span style={{ fontSize:11, color:T.muted, whiteSpace:'nowrap' }}>{fmt(time)}/{fmt(dur)}</span>
      <audio ref={aRef} src={src} onTimeUpdate={() => setTime(aRef.current?.currentTime||0)} onLoadedMetadata={() => setDur(aRef.current?.duration||0)} onEnded={() => setPlaying(false)} />
    </div>
  );
}

// ─── PDF Attachment Row ───────────────────────────────────────
function PdfRow({ pdf }: { pdf: { url: string; label: string } }) {
  return (
    <a href={pdf.url} target="_blank" rel="noreferrer" style={{ textDecoration:'none' }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, background:'#FFF7ED', border:`1px solid #FED7AA`, borderRadius:10, padding:'10px 12px', cursor:'pointer', transition:'background 0.15s' }}
        onMouseEnter={e => (e.currentTarget as HTMLElement).style.background='#FFEDD5'}
        onMouseLeave={e => (e.currentTarget as HTMLElement).style.background='#FFF7ED'}>
        <div style={{ width:32, height:32, borderRadius:7, background:'#DC2626', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <span style={{ color:'#fff', fontSize:8, fontWeight:800, letterSpacing:'0.03em' }}>PDF</span>
        </div>
        <span style={{ flex:1, fontSize:13, fontWeight:600, color:T.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{pdf.label}</span>
        <span style={{ color:T.accent, display:'flex', alignItems:'center', gap:3, fontSize:12, fontWeight:600, flexShrink:0 }}>Open <Ic.ExtLink /></span>
      </div>
    </a>
  );
}

// ─── Main ─────────────────────────────────────────────────────
export default function PravachanReport() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [data, setData]           = useState<Record<string,any>>({});
  const [folders, setFolders]     = useState<Record<string,FolderItem>>({});
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState('');
  const [viewMode, setViewMode]   = useState<'grid'|'list'>('grid');
  const [currentFolderId, setCurrentFolderId] = useState<string|null>(null);
  const [folderPath, setFolderPath] = useState<FolderItem[]>([]);
  const [selected, setSelected]   = useState<PravachanEntry|null>(null);
  const [editingId, setEditingId] = useState<string|null>(null);
  const [editForm, setEditForm]   = useState({ vakta:'', topic:'', notes:'', caption:'' });
  const [showNewFolder, setShowNewFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [posting, setPosting]     = useState<string|null>(null);
  const [unposting, setUnposting] = useState<string|null>(null);
  const [genPDF, setGenPDF]       = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  // Lightbox for images in detail panel
  const [lightboxUrl, setLightboxUrl] = useState<string|null>(null);

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  useEffect(() => {
    if (!currentUser) return;
    const load = async () => {
      try {
        const [pSnap, fSnap] = await Promise.all([
          get(ref(dbRealtime, `users/${currentUser.uid}/kathaAmrut`)),
          get(ref(dbRealtime, `users/${currentUser.uid}/folders`)),
        ]);
        setData(pSnap.exists() ? pSnap.val() : {});
        if (fSnap.exists()) {
          setFolders(fSnap.val());
        } else {
          const def = { root: { id:'root', name:'My Pravachans', parentId:null, createdAt:Date.now() } };
          setFolders(def);
          await update(ref(dbRealtime, `users/${currentUser.uid}/folders`), def);
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    load();
  }, [currentUser]);

  const stripHtml = (html: string) => { const d=document.createElement('div'); d.innerHTML=html||''; return d.textContent||''; };

  const getPravachans = (): PravachanEntry[] => {
    let arr = Object.entries(data).map(([ts, v]: any) => ({ timestamp:ts, ...v, dateObj: new Date(v.dateTime||Number(ts)) }));
    if (currentFolderId) arr = arr.filter(p => p.folderId === currentFolderId);
    if (search) {
      const q = search.toLowerCase();
      arr = arr.filter(p => p.topic?.toLowerCase().includes(q) || p.vakta?.toLowerCase().includes(q) || stripHtml(p.notes||'').toLowerCase().includes(q));
    }
    return arr.sort((a,b) => b.dateObj.getTime() - a.dateObj.getTime());
  };

  const getSubfolders = () => Object.values(folders).filter(f => f.parentId === currentFolderId);

  const navFolder = (id: string|null) => {
    if (id === null) { setCurrentFolderId(null); setFolderPath([]); setSelected(null); setShowDetail(false); return; }
    const folder = folders[id]; if (!folder) return;
    if (currentFolderId) setFolderPath(prev => [...prev, folders[currentFolderId]]);
    setCurrentFolderId(id); setSelected(null); setShowDetail(false);
  };

  const navBack = () => {
    const path = [...folderPath]; const prev = path.pop();
    setFolderPath(path); setCurrentFolderId(prev?.id||null); setSelected(null); setShowDetail(false);
  };

  const createFolder = async () => {
    if (!newFolderName.trim() || !currentUser) return;
    const id = `folder-${Date.now()}`;
    const folder: FolderItem = { id, name:newFolderName.trim(), parentId:currentFolderId, createdAt:Date.now() };
    await update(ref(dbRealtime, `users/${currentUser.uid}/folders`), { [id]: folder });
    setFolders(prev => ({ ...prev, [id]: folder }));
    setNewFolderName(''); setShowNewFolder(false);
  };

  const handleDelete = async (ts: string) => {
    if (!currentUser || !window.confirm('Delete this pravachan?')) return;
    const entry = data[ts];
    if (entry?.isPublic) {
      const feedId = `feed_${currentUser.uid}_${new Date(entry.dateTime).getTime() || entry.createdAt || Number(ts)}`;
      await remove(ref(dbRealtime, `publicFeed/${feedId}`)).catch(() => {});
    }
    await remove(ref(dbRealtime, `users/${currentUser.uid}/kathaAmrut/${ts}`));
    const nd = { ...data }; delete nd[ts]; setData(nd); setSelected(null); setShowDetail(false);
  };

  const openEdit = (p: PravachanEntry) => {
    setEditingId(p.timestamp);
    setEditForm({ vakta:p.vakta, topic:p.topic, notes:stripHtml(p.notes||''), caption:p.caption||'' });
  };

  const saveEdit = async () => {
    if (!editingId || !currentUser) return;
    await update(ref(dbRealtime, `users/${currentUser.uid}/kathaAmrut/${editingId}`), {
      vakta:editForm.vakta, topic:editForm.topic, notes:editForm.notes, caption:editForm.caption,
    });
    setData(prev => ({ ...prev, [editingId]: { ...prev[editingId], ...editForm } }));
    if (selected?.timestamp === editingId) setSelected(prev => prev ? { ...prev, ...editForm, dateObj:prev.dateObj } : null);
    setEditingId(null);
  };

  const postToFeed = async (p: PravachanEntry) => {
    if (!currentUser) return;
    setPosting(p.timestamp);
    try {
      const profSnap = await get(ref(dbRealtime, `users/${currentUser.uid}/profile`));
      let displayName = currentUser.email?.split('@')[0] || 'Devotee';
      let avatarUrl = null;
      if (profSnap.exists()) {
        const pr = profSnap.val();
        displayName = `${pr.firstName||''} ${pr.lastName||''}`.trim() || displayName;
        avatarUrl = pr.avatarUrl || null;
      }
      const ts = new Date(p.dateTime).getTime() || p.dateObj.getTime();
      const feedId = `feed_${currentUser.uid}_${ts}`;
      await set(ref(dbRealtime, `publicFeed/${feedId}`), {
        userId:        currentUser.uid,
        displayName,
        avatarInitial: displayName.charAt(0).toUpperCase(),
        avatarUrl,
        topic:         p.topic,
        vakta:         p.vakta,
        caption:       p.caption||'',
        dateTime:      p.dateTime,
        notes:         p.notes||'',
        images:        p.images||[],
        audioFiles:    p.audioFiles||[],
        pdfFiles:      p.pdfFiles||[],
        createdAt:     ts,
        likes:{}, comments:{}, saves:{},
      });
      await update(ref(dbRealtime, `users/${currentUser.uid}/kathaAmrut/${p.timestamp}`), { isPublic:true });
      setData(prev => ({ ...prev, [p.timestamp]: { ...prev[p.timestamp], isPublic:true } }));
      setSelected(prev => prev?.timestamp === p.timestamp ? { ...prev, isPublic:true } : prev);
      alert('Posted to community feed!');
    } catch (e) { console.error(e); alert('Failed to post. Check Firebase rules.'); }
    finally { setPosting(null); }
  };

  const unpostFromFeed = async (p: PravachanEntry) => {
    if (!currentUser || !window.confirm('Remove this from the public feed?')) return;
    setUnposting(p.timestamp);
    try {
      const ts = new Date(p.dateTime).getTime() || p.dateObj.getTime();
      const feedId = `feed_${currentUser.uid}_${ts}`;
      await remove(ref(dbRealtime, `publicFeed/${feedId}`));
      await update(ref(dbRealtime, `users/${currentUser.uid}/kathaAmrut/${p.timestamp}`), { isPublic: false });
      setData(prev => ({ ...prev, [p.timestamp]: { ...prev[p.timestamp], isPublic: false } }));
      setSelected(prev => prev?.timestamp === p.timestamp ? { ...prev, isPublic: false } : prev);
      alert('Removed from community feed.');
    } catch (e) { console.error(e); alert('Failed to unpost.'); }
    finally { setUnposting(null); }
  };

  const downloadPDF = async (p: PravachanEntry) => {
    setGenPDF(true);
    try {
      const div = document.createElement('div');
      div.style.cssText = 'position:absolute;left:-9999px;width:210mm;padding:20mm;font-family:sans-serif;background:#fff';
      div.innerHTML = `
        <h1 style="text-align:center;color:#C2610A;font-size:20pt;margin-bottom:10pt">${p.topic}</h1>
        <p style="text-align:right;color:#1A1714;font-size:12pt;margin:0">— ${p.vakta}</p>
        <p style="text-align:right;color:#8A8178;font-size:10pt;margin:0 0 16pt">${p.dateObj.toLocaleString()}</p>
        ${(p.images||[]).map(u=>`<img src="${u}" style="max-width:100%;max-height:250px;object-fit:contain;display:block;margin:8px auto" crossorigin="anonymous" />`).join('')}
        <div style="font-size:12pt;line-height:1.65">${p.notes||''}</div>
      `;
      document.body.appendChild(div);
      const canvas = await html2canvas(div, { scale:2, useCORS:true, backgroundColor:'#fff' });
      const pdf    = new jsPDF('p','mm','a4');
      const w      = 210;
      pdf.addImage(canvas.toDataURL('image/jpeg',0.85), 'JPEG', 0, 0, w, canvas.height*w/canvas.width);
      pdf.save(`pravachan-${p.topic.slice(0,20)}.pdf`);
      document.body.removeChild(div);
    } catch (e) { console.error(e); }
    finally { setGenPDF(false); }
  };

  if (loading) return (
    <div style={{ height:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background: T.bg, fontFamily:'system-ui' }}>
      <div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTopColor: T.accent, borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );

  const pravachans = getPravachans();
  const subfolders = getSubfolders();

  const rowStyle: React.CSSProperties = {
    display:'flex', alignItems:'center', gap:8, padding:'7px 10px',
    borderRadius:6, cursor:'pointer', fontSize:13, color: T.text,
    border:'none', background:'none', width:'100%', textAlign:'left',
  };

  // ─── Detail Panel ─────────────────────────────────────────────
  const DetailPanel = () => {
    if (!selected) return null;
    const pdfs = Array.isArray(selected.pdfFiles) ? selected.pdfFiles.filter(Boolean) : [];
    const imgs = (selected.images||[]).filter(Boolean);
    const auds = (selected.audioFiles||[]).filter(Boolean);

    return (
      <div style={{
        ...(isMobile ? {
          position: 'fixed', inset: 0, zIndex: 100, background: T.surface,
          overflowY: 'auto', display: showDetail ? 'flex' : 'none', flexDirection: 'column',
        } : {
          width: 360, borderLeft:`1px solid ${T.border}`, background: T.surface,
          overflowY:'auto', flexShrink:0, display:'flex', flexDirection:'column',
        })
      }}>
        {/* Header */}
        <div style={{ padding:'12px 16px', borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, background:T.surface, zIndex:10 }}>
          {isMobile && (
            <button onClick={() => setShowDetail(false)} style={{ background:'none', border:'none', cursor:'pointer', color:T.muted, marginRight:8 }}>
              <Ic.Back />
            </button>
          )}
          <h2 style={{ margin:0, fontSize:15, fontWeight:700, color:T.text, flex:1 }}>{selected.topic}</h2>
          {!isMobile && (
            <button onClick={() => setSelected(null)} style={{ background:'none', border:'none', cursor:'pointer', color:T.muted }}><Ic.Close /></button>
          )}
        </div>

        {/* Actions */}
        <div style={{ display:'flex', gap:6, padding:'10px 14px', borderBottom:`1px solid ${T.border}`, flexWrap:'wrap' }}>
          <button onClick={() => openEdit(selected)} style={{ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', background:T.surface2, border:`1px solid ${T.border}`, borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600, color:T.text }}>
            <Ic.Edit /> Edit
          </button>
          <button onClick={() => downloadPDF(selected)} disabled={genPDF} style={{ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', background:T.accentBg, border:`1px solid rgba(194,97,10,0.3)`, borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600, color:T.accent }}>
            <Ic.Download /> {genPDF ? 'Generating…' : 'PDF'}
          </button>
          {!selected.isPublic ? (
            <button onClick={() => postToFeed(selected)} disabled={posting===selected.timestamp} style={{ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', background:'#FEF3C7', border:`1px solid #FDE68A`, borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600, color:'#92400E' }}>
              <Ic.Globe /> {posting===selected.timestamp ? 'Posting…' : 'Post to Feed'}
            </button>
          ) : (
            <button onClick={() => unpostFromFeed(selected)} disabled={unposting===selected.timestamp} style={{ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', background:'#FEF3C7', border:`1px solid #FDE68A`, borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600, color:'#92400E' }}>
              <Ic.Unpost /> {unposting===selected.timestamp ? 'Removing…' : 'Unpost'}
            </button>
          )}
          <button onClick={() => handleDelete(selected.timestamp)} style={{ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', background:'#FEF2F2', border:`1px solid #FECACA`, borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600, color:T.red, marginLeft:'auto' }}>
            <Ic.Trash />
          </button>
        </div>

        {/* Public badge */}
        {selected.isPublic && (
          <div style={{ margin:'8px 14px 0', background:T.accentBg, border:`1px solid rgba(194,97,10,0.25)`, borderRadius:8, padding:'6px 12px', fontSize:12, color:T.accent, fontWeight:600, display:'flex', alignItems:'center', gap:6 }}>
            <Ic.Globe /> Posted to community feed
          </div>
        )}

        {/* Meta */}
        <div style={{ padding:'12px 16px', borderBottom:`1px solid ${T.border}`, background:T.surface2 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
            <div><p style={{ margin:'0 0 2px', fontSize:10, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Speaker</p><p style={{ margin:0, fontSize:13, color:T.text }}>{selected.vakta}</p></div>
            <div><p style={{ margin:'0 0 2px', fontSize:10, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Date</p><p style={{ margin:0, fontSize:13, color:T.text }}>{selected.dateObj.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}</p></div>
          </div>
        </div>

        <div style={{ padding:'14px 16px', flex:1 }}>

          {/* Images — collage with tap-to-fullscreen */}
          {imgs.length > 0 && (
            <div style={{ marginBottom:16 }}>
              <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Images</p>
              {imgs.length === 1 ? (
                <div onClick={() => setLightboxUrl(imgs[0])} style={{ cursor:'zoom-in', borderRadius:10, overflow:'hidden', border:`1px solid ${T.border}` }}>
                  <img src={imgs[0]} alt="" style={{ width:'100%', display:'block', objectFit:'contain', maxHeight:220, background:'#000' }} />
                </div>
              ) : (
                <div style={{ display:'grid', gridTemplateColumns: imgs.length === 2 ? '1fr 1fr' : imgs.length === 3 ? '1fr 1fr 1fr' : '1fr 1fr', gap:4 }}>
                  {imgs.slice(0, imgs.length > 4 ? 4 : imgs.length).map((url, i) => (
                    <div key={i} onClick={() => setLightboxUrl(url)} style={{ position:'relative', cursor:'zoom-in', borderRadius:8, overflow:'hidden', border:`1px solid ${T.border}` }}>
                      <img src={url} alt="" style={{ width:'100%', aspectRatio:'1', objectFit:'cover', display:'block' }} />
                      {/* +N overlay on last slot if more than 4 */}
                      {imgs.length > 4 && i === 3 && (
                        <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                          <span style={{ color:'#fff', fontSize:20, fontWeight:700 }}>+{imgs.length - 4}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Audio */}
          {auds.length > 0 && (
            <div style={{ marginBottom:16 }}>
              <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Audio</p>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {auds.map((url,i) => <AudioBar key={i} src={url} />)}
              </div>
            </div>
          )}

          {/* PDF attachments */}
          {pdfs.length > 0 && (
            <div style={{ marginBottom:16 }}>
              <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>PDF Attachments</p>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {pdfs.map((pdf, i) => <PdfRow key={i} pdf={pdf} />)}
              </div>
            </div>
          )}

          {/* Caption */}
          {selected.caption && (
            <div style={{ marginBottom:16 }}>
              <p style={{ margin:'0 0 6px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Caption</p>
              <p style={{ margin:0, fontSize:14, color:T.text, lineHeight:1.6 }}>{selected.caption}</p>
            </div>
          )}

          {/* Notes */}
          <div>
            <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>Notes</p>
            {selected.notes ? (
              <div dangerouslySetInnerHTML={{ __html: selected.notes }} style={{ fontSize:14, lineHeight:1.7, color:T.text, wordBreak:'break-word' }} />
            ) : (
              <p style={{ color:T.muted, fontSize:13, fontStyle:'italic' }}>No notes recorded.</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ height:'100vh', display:'flex', flexDirection:'column', background:T.bg, fontFamily:'system-ui, sans-serif', fontSize:13, overflow:'hidden' }}>

      {/* ── Lightbox ── */}
      {lightboxUrl && (
        <div onClick={() => setLightboxUrl(null)} style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,0.92)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'zoom-out' }}>
          <img src={lightboxUrl} alt="" style={{ maxWidth:'95vw', maxHeight:'95vh', objectFit:'contain', borderRadius:8 }} />
          <button onClick={() => setLightboxUrl(null)} style={{ position:'absolute', top:16, right:16, background:'rgba(255,255,255,0.15)', border:'none', borderRadius:'50%', width:36, height:36, color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(4px)' }}><Ic.Close /></button>
        </div>
      )}

      {/* Title bar */}
      <div style={{ background:T.surface, borderBottom:`1px solid ${T.border}`, padding:'10px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ color:T.accent }}><Ic.Folder /></span>
          <span style={{ fontWeight:700, color:T.text, fontSize:15 }}>Pravachan Explorer</span>
        </div>
        <span style={{ fontSize:11, color:T.muted }}>{pravachans.length} items</span>
      </div>

      {/* Toolbar */}
      <div style={{ background:T.surface2, borderBottom:`1px solid ${T.border}`, padding:'6px 10px', display:'flex', alignItems:'center', gap:6, flexShrink:0, flexWrap:'wrap' }}>
        <button onClick={navBack} disabled={folderPath.length===0} style={{ padding:'5px 8px', background:'none', border:`1px solid ${T.border}`, borderRadius:6, cursor:folderPath.length ? 'pointer':'not-allowed', opacity:folderPath.length?1:0.4, color:T.text }}>
          <Ic.Back />
        </button>
        <div style={{ display:'flex', alignItems:'center', gap:4, flex:1, minWidth:0, background:T.surface, border:`1px solid ${T.border}`, borderRadius:6, padding:'5px 10px', overflowX:'auto' }}>
          <button onClick={() => navFolder(null)} style={{ background:'none', border:'none', cursor:'pointer', color:T.accent, fontSize:12, whiteSpace:'nowrap', fontWeight:600 }}>All</button>
          {folderPath.map((f, i) => (
            <React.Fragment key={f.id}>
              <span style={{ color:T.muted }}>›</span>
              <button onClick={() => { setFolderPath(folderPath.slice(0,i+1)); setCurrentFolderId(f.id); }} style={{ background:'none', border:'none', cursor:'pointer', color:T.accent, fontSize:12, whiteSpace:'nowrap' }}>{f.name}</button>
            </React.Fragment>
          ))}
          {currentFolderId && folders[currentFolderId] && (
            <><span style={{ color:T.muted }}>›</span><span style={{ fontSize:12, fontWeight:600, whiteSpace:'nowrap', color:T.text }}>{folders[currentFolderId].name}</span></>
          )}
        </div>
        <div style={{ display:'flex', gap:2 }}>
          <button onClick={() => setViewMode('grid')} style={{ padding:'5px 8px', background:viewMode==='grid'?T.accentBg:'none', border:`1px solid ${viewMode==='grid'?T.accent:T.border}`, borderRadius:6, cursor:'pointer', color:viewMode==='grid'?T.accent:T.muted }}><Ic.Grid /></button>
          <button onClick={() => setViewMode('list')} style={{ padding:'5px 8px', background:viewMode==='list'?T.accentBg:'none', border:`1px solid ${viewMode==='list'?T.accent:T.border}`, borderRadius:6, cursor:'pointer', color:viewMode==='list'?T.accent:T.muted }}><Ic.List /></button>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:4, background:T.surface, border:`1px solid ${T.border}`, borderRadius:6, padding:'5px 10px' }}>
          <span style={{ color:T.muted }}><Ic.Search /></span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search…"
            style={{ border:'none', outline:'none', fontSize:12, width:isMobile?80:130, fontFamily:'inherit', background:'transparent', color:T.text }} />
        </div>
        <button onClick={() => setShowNewFolder(true)} style={{ display:'flex', alignItems:'center', gap:4, padding:'5px 10px', background:'none', border:`1px solid ${T.border}`, borderRadius:6, fontSize:12, color:T.muted, cursor:'pointer', whiteSpace:'nowrap' }}>
          <Ic.Plus /> {!isMobile && 'Folder'}
        </button>
      </div>

      {/* Body */}
      <div style={{ flex:1, display:'flex', overflow:'hidden' }}>
        {/* Sidebar */}
        {!isMobile && (
          <div style={{ width:190, background:T.surface, borderRight:`1px solid ${T.border}`, overflowY:'auto', flexShrink:0, padding:'8px 6px' }}>
            <p style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', color:T.muted, padding:'4px 6px', margin:0 }}>Quick Access</p>
            <button onClick={() => navFolder(null)} style={{ ...rowStyle, background: currentFolderId===null ? T.accentBg : 'none', color: currentFolderId===null ? T.accent : T.text }}>
              <Ic.File /> All Pravachans
              <span style={{ marginLeft:'auto', background:T.surface2, borderRadius:10, padding:'1px 6px', fontSize:11, color:T.muted }}>{Object.keys(data).length}</span>
            </button>
            <p style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', color:T.muted, padding:'8px 6px 4px', margin:0 }}>Folders</p>
            {Object.values(folders).filter(f => !f.parentId).map(f => (
              <button key={f.id} onClick={() => navFolder(f.id)} style={{ ...rowStyle, background: currentFolderId===f.id ? T.accentBg : 'none', color: currentFolderId===f.id ? T.accent : T.text }}>
                <Ic.Folder /> <span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{f.name}</span>
              </button>
            ))}
          </div>
        )}

        {/* File area */}
        <div style={{ flex:1, overflowY:'auto', display:'flex', flexDirection:'column', minWidth:0 }}>
          <div style={{ padding:'4px 12px', background:T.surface2, borderBottom:`1px solid ${T.border}`, fontSize:11, color:T.muted, flexShrink:0 }}>
            {pravachans.length} pravachan{pravachans.length!==1?'s':''}{subfolders.length ? ` · ${subfolders.length} folder${subfolders.length!==1?'s':''}` : ''}
          </div>

          <div style={{ flex:1, padding:12, overflowY:'auto' }}>
            {showNewFolder && (
              <div style={{ display:'flex', gap:8, marginBottom:12, alignItems:'center', background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, padding:'8px 12px' }}>
                <span style={{ color:T.accent }}><Ic.Folder /></span>
                <input autoFocus value={newFolderName} onChange={e => setNewFolderName(e.target.value)}
                  onKeyDown={e => { if (e.key==='Enter') createFolder(); if (e.key==='Escape') setShowNewFolder(false); }}
                  placeholder="Folder name…"
                  style={{ flex:1, border:'none', outline:'none', fontSize:13, fontFamily:'inherit', background:'transparent', color:T.text }} />
                <button onClick={createFolder} style={{ background:T.accent, color:'#fff', border:'none', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontSize:12, fontWeight:600 }}>Create</button>
                <button onClick={() => setShowNewFolder(false)} style={{ background:'none', border:'none', cursor:'pointer', color:T.muted }}><Ic.Close /></button>
              </div>
            )}

            {viewMode === 'grid' ? (
              <div style={{ display:'grid', gridTemplateColumns:`repeat(auto-fill,minmax(${isMobile?'90px':'120px'},1fr))`, gap:8 }}>
                {subfolders.map(f => (
                  <button key={f.id} onClick={() => navFolder(f.id)}
                    style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:5, padding:'14px 8px', background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, cursor:'pointer', transition:'all 0.15s' }}
                    onMouseEnter={e => { e.currentTarget.style.background=T.accentBg; e.currentTarget.style.borderColor=T.accent; }}
                    onMouseLeave={e => { e.currentTarget.style.background=T.surface; e.currentTarget.style.borderColor=T.border; }}>
                    <div style={{ fontSize:36 }}>📁</div>
                    <span style={{ fontSize:11, textAlign:'center', wordBreak:'break-word', color:T.text, lineHeight:1.3 }}>{f.name}</span>
                    <span style={{ fontSize:10, color:T.muted }}>{Object.values(data).filter((p:any) => p.folderId===f.id).length} items</span>
                  </button>
                ))}
                {pravachans.map(p => (
                  <button key={p.timestamp} onClick={() => { setSelected(p); setShowDetail(true); }}
                    style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:5, padding:'14px 8px', background: selected?.timestamp===p.timestamp ? T.accentBg : T.surface, border:`1px solid ${selected?.timestamp===p.timestamp ? T.accent : T.border}`, borderRadius:10, cursor:'pointer', transition:'all 0.15s' }}
                    onMouseEnter={e => { if (selected?.timestamp!==p.timestamp) e.currentTarget.style.background=T.surface2; }}
                    onMouseLeave={e => { if (selected?.timestamp!==p.timestamp) e.currentTarget.style.background=T.surface; }}>
                    <div style={{ fontSize:32 }}>📝</div>
                    <span style={{ fontSize:11, textAlign:'center', wordBreak:'break-word', color:T.text, lineHeight:1.3, maxWidth:'100%' }}>{p.topic}</span>
                    <span style={{ fontSize:10, color:T.muted, textAlign:'center' }}>{p.vakta}</span>
                    {p.isPublic && <span style={{ fontSize:9, background:T.accentBg, color:T.accent, borderRadius:10, padding:'1px 6px', fontWeight:700, border:`1px solid rgba(194,97,10,0.3)` }}>PUBLIC</span>}
                    {/* Small badges for attachments */}
                    <div style={{ display:'flex', gap:3, flexWrap:'wrap', justifyContent:'center' }}>
                      {(p.images||[]).length > 0 && <span style={{ fontSize:8, background:T.surface2, borderRadius:8, padding:'1px 5px', color:T.muted }}>🖼 {(p.images||[]).length}</span>}
                      {(p.audioFiles||[]).length > 0 && <span style={{ fontSize:8, background:T.surface2, borderRadius:8, padding:'1px 5px', color:T.muted }}>🎵 {(p.audioFiles||[]).length}</span>}
                      {(p.pdfFiles||[]).length > 0 && <span style={{ fontSize:8, background:'#FFF7ED', borderRadius:8, padding:'1px 5px', color:'#DC2626', border:'1px solid #FED7AA' }}>PDF {(p.pdfFiles||[]).length}</span>}
                    </div>
                  </button>
                ))}
              </div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%', borderCollapse:'collapse', minWidth:400 }}>
                  <thead>
                    <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                      {['Name','Speaker','Date','Attachments','Status'].map(h => (
                        <th key={h} style={{ textAlign:'left', padding:'6px 8px', fontSize:11, fontWeight:700, textTransform:'uppercase', color:T.muted }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {pravachans.map(p => (
                      <tr key={p.timestamp} onClick={() => { setSelected(p); setShowDetail(true); }} style={{ cursor:'pointer', background: selected?.timestamp===p.timestamp ? T.accentBg : 'none', borderBottom:`1px solid ${T.border}` }}
                        onMouseEnter={e => { if (selected?.timestamp!==p.timestamp) (e.currentTarget as HTMLElement).style.background=T.surface2; }}
                        onMouseLeave={e => { if (selected?.timestamp!==p.timestamp) (e.currentTarget as HTMLElement).style.background='none'; }}>
                        <td style={{ padding:'8px 8px' }}><div style={{ display:'flex', alignItems:'center', gap:6 }}><span>📝</span><span style={{ color:T.text, fontSize:13 }}>{p.topic}</span></div></td>
                        <td style={{ padding:'8px 8px', color:T.muted, fontSize:12 }}>{p.vakta}</td>
                        <td style={{ padding:'8px 8px', color:T.muted, fontSize:12, whiteSpace:'nowrap' }}>{p.dateObj.toLocaleDateString()}</td>
                        <td style={{ padding:'8px 8px' }}>
                          <div style={{ display:'flex', gap:4 }}>
                            {(p.images||[]).length > 0 && <span style={{ fontSize:10, background:T.surface2, borderRadius:8, padding:'2px 6px', color:T.muted }}>🖼 {(p.images||[]).length}</span>}
                            {(p.audioFiles||[]).length > 0 && <span style={{ fontSize:10, background:T.surface2, borderRadius:8, padding:'2px 6px', color:T.muted }}>🎵 {(p.audioFiles||[]).length}</span>}
                            {(p.pdfFiles||[]).length > 0 && <span style={{ fontSize:10, background:'#FFF7ED', borderRadius:8, padding:'2px 6px', color:'#DC2626' }}>PDF {(p.pdfFiles||[]).length}</span>}
                          </div>
                        </td>
                        <td style={{ padding:'8px 8px' }}>{p.isPublic && <span style={{ fontSize:10, background:T.accentBg, color:T.accent, borderRadius:10, padding:'2px 7px', fontWeight:700 }}>Public</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {pravachans.length===0 && subfolders.length===0 && (
              <div style={{ textAlign:'center', padding:'60px 24px', color:T.muted }}>
                <div style={{ fontSize:40, marginBottom:12 }}>📂</div>
                <p style={{ margin:0 }}>{search ? 'No results found.' : 'This folder is empty.'}</p>
              </div>
            )}
          </div>
        </div>

        {/* Detail panel — sidebar on desktop */}
        {!isMobile && selected && <DetailPanel />}
      </div>

      {/* Detail panel — full screen on mobile */}
      {isMobile && <DetailPanel />}

      {/* Edit Modal */}
      {editingId && (
        <div style={{ position:'fixed', inset:0, background:'rgba(26,23,20,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:T.surface, borderRadius:16, padding:24, width:'100%', maxWidth:520, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.2)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
              <h3 style={{ margin:0, fontSize:17, fontWeight:700, color:T.text }}>Edit Pravachan</h3>
              <button onClick={() => setEditingId(null)} style={{ background:'none', border:'none', cursor:'pointer', color:T.muted }}><Ic.Close /></button>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {[
                { label:'Topic', key:'topic' as const },
                { label:'Speaker (Vakta)', key:'vakta' as const },
                { label:'Caption', key:'caption' as const },
              ].map(f => (
                <div key={f.key}>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:T.muted, marginBottom:4 }}>{f.label}</label>
                  <input value={(editForm as any)[f.key]} onChange={e => setEditForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                    style={{ width:'100%', boxSizing:'border-box', padding:'9px 12px', border:`1px solid ${T.border}`, borderRadius:8, fontSize:14, fontFamily:'inherit', outline:'none', color:T.text, background:T.surface }} />
                </div>
              ))}
              <div>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:T.muted, marginBottom:4 }}>Notes (plain text)</label>
                <textarea value={editForm.notes} onChange={e => setEditForm(prev => ({ ...prev, notes: e.target.value }))}
                  rows={8} style={{ width:'100%', boxSizing:'border-box', padding:'9px 12px', border:`1px solid ${T.border}`, borderRadius:8, fontSize:14, fontFamily:'inherit', resize:'vertical', outline:'none', color:T.text, background:T.surface }} />
              </div>
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:4 }}>
                <button onClick={() => setEditingId(null)} style={{ padding:'9px 20px', border:`1px solid ${T.border}`, borderRadius:8, background:'none', cursor:'pointer', fontSize:13, color:T.text }}>Cancel</button>
                <button onClick={saveEdit} style={{ padding:'9px 20px', background:T.accent, color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600 }}>Save changes</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

